import {ConfEnv} from "../../config/config";
import publicRequest from "../../Infra/http/public.request";
import {trackUserRegistration} from "../../providers/analytics";

export const postUserRegistrationSimplified = async data => {
  const response = await publicRequest.post(ConfEnv.API_URL.URL_REGISTER_SIMPLIFIED, data);

  // Track user registration
  trackUserRegistration(data.email);

  return response;
};
